module.exports = __webpack_public_path__ + "static/advance-9921bf6f4a020f9855d86d4d4600e91a.svg";